module.exports = __webpack_public_path__ + "static/media/1.12_preview.ab83c497.png";